import { scrollIntoView } from 'seamless-scroll-polyfill';

import { isElementInViewport } from './utils';

export function scrollToElement(tag: string) {
  const element = document.querySelector(tag);

  if (element && element instanceof HTMLElement && !isElementInViewport(element)) {
    scrollIntoView(element, { behavior: 'smooth', block: 'start' });
  }
}
